import { useMemo } from 'react'
import randomGenerator from 'random-seed'
import { useColor } from 'utils/colors'

export const getFormattedProfileKey = (profileKey) => {
  if (typeof profileKey !== 'string') return profileKey

  // formats:
  let keyName = ''
  if (profileKey.indexOf('\\') >= 0) {
    // i:0#.w|developer\erickm
    keyName = profileKey.split('\\')
    keyName = keyName[keyName.length - 1]
  } else {
    // i:0#.f|membership|sobot@objectconnect.de
    // i:0#.f|membership|sobot_objectconnect.de#ext#@ovark.com
    keyName = profileKey.split('|')
    keyName = keyName[keyName.length - 1]
  }
  return keyName
}

export const useUserColor = (profileKey) => {
  const colorId = useMemo(() => {
    if (!profileKey) return 15

    return randomGenerator.create(profileKey)(16)
  }, [profileKey])

  return useColor(colorId)
}

export const getUserInitials = (name) => {
  if (!name) return '?'

  let initials

  name = name.split('@')[0]

  var classicLoginParts = name.split('\\')

  if (classicLoginParts.length > 1) {
    name = classicLoginParts[1]
  }

  var nameParts = name.split(/\s+/)

  if (nameParts.length === 1) {
    initials = name.substr(0, 1) + name.substr(name.length - 1)
  } else {
    initials = nameParts[0].substr(0, 1) + nameParts[nameParts.length - 1].substr(0, 1)
  }

  if (initials.length !== 2) {
    initials = name.substr(0, 2)
  }

  return initials.toUpperCase()
}

export const convertFromToUser = (fromUser) => {
  if (!fromUser) {
    return {
      type: 'UNKNOWN',
      data: fromUser
    }
  }

  if (typeof fromUser === 'number') {
    return {
      type: 'USER',
      id: fromUser
    }
  } else {
    const userParts = fromUser.split(':')

    const type = userParts[0]
    const data = userParts[1]

    switch (type) {
      case 'u': // User
        return {
          type: 'USER',
          id: +data
        }
      case 'e': // Email
        return {
          type: 'EMAIL',
          data
        }
      case 's': // Token service
        return {
          type: 'SERVICE',
          data
        }
      case 'g': // Guid
        return {
          type: 'GUID',
          guid: data
        }
      default:
        return {
          type: 'UNKNOWN',
          data: fromUser
        }
    }
  }
}
